import constant from '../../store/constant'
import config from '../../store/config'
var utils = require('../../utils')

export default {
  name: 'clinic-detail',
  data: function () {
    return {
      shopId: null,
      history: null,
      clinicId: null,
      clinicHisId: null,
      searchCallbackFlag: false, // 検索結果フラグ
      /** 画像タイトル編集 */
      editImageTitle: null
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.googleMapEventRemove() // google map イベント削除
    this.$store.dispatch('CLEAR_CLINIC_CODE')
    next()
  },
  created: function() {
    // システム管理者 または 薬剤師
    this.$store.dispatch('USER_ADMIN_PHARMACIST')

    // this.$store.dispatch('SHOP_SEARCH')
    this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})

    if (this.$store.getters.canManage) {
      // 店舗ID
      this.shopId = this.$store.getters.currentShopId
    }
    this.clinicId = this.$route.params.clinicId
    this.search()
  },
  computed: {
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    images() {
      return this.$store.getters.clinicImages
    },
    clinic() {
      return this.$store.getters.clinic
    },
    clinicHistories() {
      return this.$store.getters.clinicHistories
    },
    uploadCounter () {
      var total = this.$store.getters.imageUploadTotal
      var current = this.$store.getters.imageUploadCurrent
      if (total < 1 || total === current) {
        return ''
      } else {
        return this.$t('Count', {'Count': current + '/' + total}) + this.$t('Image Upload Successful')
      }
    },
    uploadErrors () {
      return this.$store.getters.imageUploadErrors
    },
    uploadSuccess () {
      return this.$store.getters.imageUploadStatus
    },
    /** 画像登録ボタン 押下可否 */
    canAddImage: function () {
      if (this.images !== null) {
        return this.images.length < constant.place_image_upload_limit
      } else {
        return true
      }
    },
    /** 管理者 または 組織長かつ薬剤師 */
    isAdminOrPharmacistManager() {
      return this.$store.getters.userAdminOrPharmacistManager
    },
    notify() {
      return this.$store.getters.clinicNotify
    },
    loading() {
      return this.$store.getters.apiLoading
    },
    clinicCodeList() {
      console.log(this.$store.getters.clinicCodeList)
      return this.$store.getters.clinicCodeList
    }
  },
  methods: {
    getSendTimingName: function (sendTiming) {
      if (!utils.isBlank(sendTiming)) {
        var sendTimings = this.$t('clinic.send_timing')
        for ( var timing of sendTimings) {
          if (timing.id === utils.str2int(sendTiming)) {
            return timing.text
          }
        }
      }
    },
    getSendTimingHourName: function (sendTimingHour) {
      if (!utils.isBlank(sendTimingHour)) {
        var sendTimingHours = this.$t('clinic.send_timing_hour')
        for ( var hour of sendTimingHours) {
          if (hour.id.toString() === sendTimingHour.toString()) {
            return hour.text
          }
        }
      }
    },

    /** 検索 */
    search: function () {
      this.clinicClear()
      var data = {
        shop_id: this.shopId
      }
      this.searchCallbackFlag = false
      this.$store.dispatch('CLINIC_SHOW', {clinicId: this.clinicId, data: data, callback: this.searchCallback})
    },

    /** 履歴情報格納 */
    searchCallback: function (data) {
      if (data === null) {
        this.searchCallbackFlag = true
      }
      if (!data || data.length < 1) {
        this.goPrev()
        return
      }
      var exists = false
      for (var d of data) {
        if (d.attributes['current_flag']) {
          this.history = d.attributes
          this.clinicHisId = d.attributes['clinic_history_id']
          exists = true
          break
        }
        // 当日日付が見つからない場合先頭
        if (!exists) {
          if (data !== null && data.length > 0) {
            this.history = data[0]
            this.clinicHisId = data[0].attributes['clinic_history_id']
          }
        }
      }
      this.searchClinicCode()
      this.googleMapRender()
      this.searchCallbackFlag = true
    },
    searchClinicCode: function () {
      var data = {
        'clinic_id': this.clinicId
      }
      this.$store.dispatch('CLINIC_SEARCH_CLINIC_CODE', {data: data})
    },
    /** グーグルマップを表示 */
    googleMapRender: function () {
      if (this.history == null) {
        return
      }
      var address = ''
      if (utils.isPresent(this.history.address1)) {
        address += this.history.address1
      }
      if (utils.isPresent(this.history.address2)) {
        address += this.history.address2
      }
      var markaList = [{
        lat:     this.history.map_lat,
        lng:     this.history.map_lng,
        zoom:    this.history.map_zoom,
        title:   this.history.clinic_name,
        address: address,
      }]
      // GoogleMaps
      utils.googleMapMarkaOnlyEvent({
        js:          constant.js.google_maps,
        key:         config.google_map_api_key,
        mapElmId:    'map',
        map_default: constant.map_default,
        markaList:   markaList,
      })
    },

    /** パラメータークリア */
    clinicClear: function () {
      this.history = null
      this.clinicHisId = null
      this.$store.dispatch('CLINIC_CLEAR')
    },

    /** 日付文言取得 */
    getReferenceDate: function (d) {
      // 当日が含まれている場合
      if (d.attributes['current_flag']){
        return this.$t('history.today')
      }
      var start = utils.sereki2Wareki(this.$t, new Date(d.attributes['start_date']))
      var end = new Date(d.attributes['end_date'])
      if (end.getFullYear() == this.$t('history.max_year')) {
        end = this.$t('history.max_display')
      } else {
        end = utils.sereki2Wareki(this.$t, end)
      }
      return start + this.$t('history.delimiter') + end
    },

    /** 参照日付変更 */
    onChangeSelectDate: function () {
      for (var f of this.clinicHistories) {
        if (f.attributes['clinic_history_id'] == this.clinicHisId) {
          this.history = f.attributes
          this.googleMapRender()
          return
        }
      }
    },

    /** 取引中止 */
    onStop: function(enable_flag) {
      var data = {
        enable_flag: enable_flag,
        clinic_id: this.clinicId
      }
      this.$store.dispatch('CLINIC_STOP', { data: data, callback: this.clinicUpdateCallback })
    },

    /** ログイン・パスワード通知 */
    onSendMedinfo: function() {
      var data = {
        send_type: this.history.send_type,
        shop_id: this.shopId,
        clinic_id: this.clinicId,
        clinic_history_id: this.clinicHisId
      }
      this.$store.dispatch('CLINIC_SEND_MEDINFO', { data: data, callback: this.clinicUpdateCallback })
    },
    /** ログインID・パスワード通知PDF印刷 */
    onPrintNotifyPDF: function() {
      // 新規ウィンドウ
      var win = window.open(constant.html.loading)
      var data = {
        'shop_id':             this.shopId,
        'clinic_id':           this.clinicId,
        'clinic_history_id':   this.clinicHisId
      }

      this.$store.dispatch('CLINIC_DETAIL_PRINT_NOTIFY_PDF', {data: data, callback:this.onPrintNotifyPDFCallback, win:win})
    },
    /** ログインID・パスワード通知PDF印刷印刷コールバック */
    onPrintNotifyPDFCallback: function(data, win) {
      win.location.href = data.download
      // 後始末
      setTimeout(() => {
        this.$store.dispatch('CLINIC_DETAIL_PRINT_NOTIFY_PDF_DELETE', {data: {delete_path: data.delete_path}})
      }, constant.print_delete_time)
    },
    /** 削除 */
    onClickDelete: function() {
      this.$store.dispatch('CLINIC_DELETE', { historyId: this.clinicHisId, callback: this.search })
    },

    /** 現在の内容を最新化 */
    clinicUpdateCallback: function() {
      if (this.clinicHistories !== null) {
        for (var i = 0; i < this.clinicHistories.length; i++) {
          var d = this.clinicHistories[i].attributes
          if (parseInt(d.clinic_history_id, 10) === parseInt(this.clinicHisId, 10)) {
            this.history = this.clinicHistories[i].attributes
            break
          }
        }
      }
    },

    /** 画像押下 */
    onClickImageModalShow: function (image) {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = image.image_path + '?token=' + this.authToken
      text.textContent = image.title
      button.click() // モーダル表示 イベント発火
    },

    /** 画像タイトルリンク押下 */
    onClickTitleEditModalShow: function (image) {
      this.selectedImage = image
      this.editImageTitle = image.title
      this.$refs.editTitleBtn.click()
    },

    saveTitle: function () {
      this.selectedImage.title = this.editImageTitle
    },

    removeImage: function (image) {
      if (image) image.del_flag = constant.facility.del_flag.on // 1
    },

    /** 画像登録ボタン 押下 */
    onClickUploadModalShow: function () {
      if (this.canAddImage) {
        var button = document.getElementById('images_upload_modal_button')
        button.click() // モーダル表示 イベント発火
        this.uploadStart()
      }
    },

    uploadStart: function () {
      this.$store.dispatch('IMAGE_UPLOAD_START')
    },

    upload: function (files) {
      if (!files)
        return
      if (!this.canAddImage)
        return
      for (var i=0; i<files.length; i++) {
        var formData = new FormData()
        formData.append('image_attach[cache_id]', files[i])
        this.$store.dispatch('IMAGE_UPLOAD', { data: formData, callback: this.onUpload })
      }
    },
    onUpload: function (data) {
      var img = {}
      img.id              = null
      img.title           = data.title
      img.image_attach_id = null
      img.cache_id        = data.cache_id
      img.cache_id_cache  = data.cache_id_cache
      img.image_path      = data.image_path
      img.del_flag        = constant.facility.del_flag.off
      this.images.push(img)
    },
    onDragOver: function (event) {
      var files = event.dataTransfer.items
      if (files && (!this.canAddImage)) {
        event.dataTransfer.dropEffect = "none"
      }
      event.preventDefault()
    },
    onDrop: function (event) {
      // ブラウザ上でファイルを展開する挙動を抑止
      event.preventDefault()

      // ドロップされたファイルのfilesプロパティを参照
      if (this.canAddImage) {
        var files = event.dataTransfer.files
        this.upload(files)
      }
    },
    onFileChange: function (event) {
      // ドロップされたファイルのfilesプロパティを参照
      var files = event.target.files
      this.upload(files)
    },

    onClickSave: function () {
      var data = {
        clinic_id:this.clinicId,
        images:   this.images
      }
      this.$store.dispatch('CLINIC_IMAGE_SAVE', {data: data, callback: this.onSaved})
    },

    onSaved: function () {
      this.$router.push({path: '/clinics/' + this.$route.params.clinicId, query: {type: this.$router.currentRoute.query.type}})
    },

    goFacilities: function () {
      this.$router.push({ path: '/facilities', query: { type: this.$router.currentRoute.query.type } })
    },
    goFacilityPersons: function () {
      this.$router.push({ path: '/facility_persons', query: { type: this.$router.currentRoute.query.type } })
    },
    goCareOffices: function () {
      this.$router.push({ path: '/care_offices', query: { type: this.$router.currentRoute.query.type } })
    },
    goClinics: function () {
      this.$router.push({ path: '/clinics', query: { type: this.$router.currentRoute.query.type } })
    },
    goCareManagers: function () {
      this.$router.push({ path: '/care_managers', query: { type: this.$router.currentRoute.query.type } })
    },
    goDoctorList: function () {
      this.$router.push({ path: '/doctors', query: { type: this.$router.currentRoute.query.type } })
    },
    goClinicDoctors: function () {
      this.$router.push({ path: '/doctors/list/' + this.clinicId, query: { type: this.$router.currentRoute.query.type } })
    },
    goPrev: function() {
      this.$router.push({ path: '/clinics', query: {type: this.$router.currentRoute.query.type, keep: 'true' } })
    },
    goClinicEdit: function () {
      if (utils.isPresent(this.clinicId) && utils.isPresent(this.clinicHisId)) {
        this.$router.push({path: '/clinics/' + this.clinicId + '/' + this.clinicHisId + '/edit', query: { type: this.$router.currentRoute.query.type } })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/clinic-detail.js